import { render, staticRenderFns } from "./SpriteIcon.vue?vue&type=template&id=1780de19&"
import script from "./SpriteIcon.vue?vue&type=script&lang=js&"
export * from "./SpriteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports